export default __webpack_public_path__ + "static/media/64.3533a795.jpg";